module.exports = __webpack_public_path__ + "static/cabina-conductor---cupula-72afc9e789a583eabed6b3f9cced1d44.jpg";